import React from "react";

import { Shimmer, ShimmerKeyframes } from "./Shimmer";

type Props = {
  rowCount?: number;
  columnCount?: number;
};

const d = (n: number) => `${n}s`;

const WorkOrderTableSkeleton = ({ rowCount = 10, columnCount = 7 }: Props) => {
  const columns = Array.from({ length: columnCount });

  return (
    <>
      <ShimmerKeyframes />
      <div className="w-full overflow-hidden border border-solid border-primary rounded-lg bg-primary">
        <div
          className="grid items-center gap-lg px-lg py-md bg-tertiary border-solid border-0 border-b border-primary"
          style={{
            gridTemplateColumns: `40px repeat(${
              columnCount - 1
            }, minmax(120px, 1fr))`,
          }}
        >
          <Shimmer className="h-md w-md rounded" delay={d(0)} />
          {columns.slice(1).map((_, i) => (
            <Shimmer
              key={i}
              className="h-md w-[80px] rounded"
              delay={d(0.04 * i)}
            />
          ))}
        </div>

        {Array.from({ length: rowCount }).map((_, rowIdx) => (
          <div
            key={rowIdx}
            className="grid items-center gap-lg px-lg py-md border-solid border-0 border-b border-primary last:border-b-0"
            style={{
              gridTemplateColumns: `40px repeat(${
                columnCount - 1
              }, minmax(120px, 1fr))`,
            }}
          >
            <Shimmer className="h-md w-md rounded" delay={d(rowIdx * 0.05)} />
            {columns.slice(1).map((_, colIdx) => {
              const isFirst = colIdx === 0;
              return (
                <div key={colIdx} className="flex items-center gap-sm">
                  {isFirst && (
                    <Shimmer
                      className="w-2xl h-2xl rounded-full flex-shrink-0"
                      delay={d(rowIdx * 0.05 + colIdx * 0.02)}
                    />
                  )}
                  <Shimmer
                    className={`h-md rounded ${
                      isFirst
                        ? "w-[140px]"
                        : colIdx % 2 === 0
                        ? "w-[60%]"
                        : "w-[80%]"
                    }`}
                    delay={d(rowIdx * 0.05 + colIdx * 0.02 + 0.01)}
                  />
                </div>
              );
            })}
          </div>
        ))}
      </div>
    </>
  );
};

export default WorkOrderTableSkeleton;
